import { render } from "./AgileTeams.vue?vue&type=template&id=60c67508&ts=true"
import script from "./AgileTeams.vue?vue&type=script&lang=ts"
export * from "./AgileTeams.vue?vue&type=script&lang=ts"

import "./AgileTeams.vue?vue&type=style&index=0&id=60c67508&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__